import { useMutation, useQueryClient } from '@tanstack/react-query';

import { usersKey } from '@pages/Users/services/useUsersInfiniteQuery';

import { apiClient } from '@services/apiClient';

const userDeleteFn = (data) => apiClient.delete(`${APP_SSO_URL}api/full-service/user/delete`, { data });

export const useUserDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: userDeleteFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [usersKey()[0]], exact: false });
    },
  });
};
